export const WEB_ROUTES = {
  REGISTRATION_STEP_1: 'registration',
  REGISTRATION_STEP_2: 'registration-step2',
  REGISTRATION_STEP_3: 'registration-step3',
  REGISTRATION_STEP_4: 'registration-step4',
  REGISTRATION_STEP_6: 'registration-step6',
  PROFILE: 'profile',
  PROFILE_BIOMETRY_EDIT: 'profile-edit',
  PROFILE_BIOMETRY: 'profile-biometry',
  PROFILE_BIOMETRY_REJECTED: 'profile-biometry-rejected',
  PROFILE_BIOMETRY_LOADING: 'profile-biometry-loading',
  PROFILE_MY_LOAN: 'profile-my-loan',
  PROFILE_NO_LOAN: 'profile-no-loan',
  PROFILE_CHANGE_PASSWORD: 'profile-change-password',
  CHANGE_EMAIL: 'change-email',
  LOGIN: 'login',
  MAIN: 'index',
  LANDING_GA: 'landing-ga',
  DISCOUNT: 'discount-company',
  HOW_TO_GET: 'loan',
  HOW_TO_PAY: 'repay',
  DOCUMENTS: 'documents',
  FAQ: 'faq',
  RECOVER: 'recover',
  CONTACT: 'contact',
  ABOUT: 'about',
  HOW_TO_APPLY: 'how-to-apply',
  HOW_TO_REPAY: 'how-to-repay',
  APPLY: 'application-apply',
  APPLICATION_REJECTED: 'application-rejected',
  APPLICATION_LOADING: 'application-loading',
  APPLICATION_LOADING_VIDEO: 'application-loading-video-verification',
  APPLICATION_OFFER_DECREASE: 'application-offer-decrease',
  APPLICATION_OFFER_INCREASE: 'application-offer-increase',
  APPLICATION_OPERATOR_OFFER_DECREASE: 'application-operator-offer-decrease',
  DECISION_EXPRESS_REDIRECT: 'decision-express',
  ROLLOVER_OTP: 'rollover-otp',
  CONSIDERATION_TYPE: 'ct',
  CONSIDERATION_TYPE_DELAY_DECISION: 'ct-dd',
  CONSIDERATION_TYPE_INSURANCE: 'ct-ins',
  CONSIDERATION_TYPE_GUARANTOR: 'ct-gr',
  CONSIDERATION_TYPE_WITHOUT_INSURANCE: 'ct-wo-ins',
  FINANCE_REPORT: 'finance-report',
  COMPLAINS: 'complains',
  SELECT_VERIFICATION: 'select-verification',
  VIDEO_CAPTURE: 'video-capture',
  MANUAL_VERIFICATION: 'application-manual-verification',
  RECOVER_BY_EMAIL: 'recover-email',
  RECOVER_BY_SMS: 'recover-sms',
};

export const DISPATCH_API = {
  CREATE_BIOMETRY: 'http/createBiometry',
  UPLOAD_BIOMETRY_PHOTO: 'http/uploadBiometryPhoto',
  UPDATE_MOBILE: 'client/changePhone',
  UPDATE_EMAIL: 'client/changeEmail',
  SEND_SMS: 'client/sendSms',
  SEND_EMAIL_CODE: 'client/sendEmail',
  RECOVER_CLIENT: 'client/recover',
  CLIENT_RECOVER: 'client/recover',
  CLIENT_CREATE: 'client/create',
  CLIENT_UPDATE: 'client/update',
  CLIENT_ADD_CONTACT: 'client/addContact',
  CLIENT_CAPTURE_BEHAVIOUR: 'client/captureBehaviour',
  CLIENT_FIND: 'client/find',
  CLIENT_CREATE_APPLICATION: 'client/createApplication',
  CLIENT_UPLOAD_DOCUMENT: 'client/uploadDocument',
  APPROVE_DECREASE: 'http/approveDecrease',
  CLIENT_APPROVE_DECREASE: 'client/approveDecrease',
  APPROVE_OPERATOR_DECREASE: 'http/approveOperatorDecrease',
  APPROVE_INCREASE: 'http/approveIncrease',
  CLIENT_REFUSE_INCREASE: 'client/refuseIncrease',
  COMPLETE_STEP_TWO: 'client/completeStepTwo',
  COMPLETE_STEP_THREE: 'client/completeStepThree',
  COMPLETE_STEP_FOUR: 'client/completeStepFour',
  GET_BIOMETRY_STATUS: 'http/getActualBiometryStatus',
  GET_APPLICATION_STATUS: 'client/getApplicationStatus',
  GET_APPLICATION: 'client/getApplication',
  GET_LOCALIZATIONS: 'http-public/getLocalizations',
  GET_REGIONS: 'geo/getRegions',
  UPDATE_IBAN: 'http/updateIban',
  VERIFY_IBAN: 'client/verifyIban',
  CHANGE_PASSWORD: 'client/changePassword',
  GET_DEBT_ITEMS: 'http/getDebtItems',
  CLEAR_PROMO_CODE: 'arithmetic/clearPromoCode',
  UPDATE_OFFICE_LOCATION: 'http/updateOfficeLocation',
  SEND_PRIVATE_SMS: 'client/sendPrivateSms',
  VERIFY_PRIVATE_SMS: 'client/verifyPrivateSms',
  GET_BIOMETRY_CONFIG: 'http-public/getBiometryConfig',
  UPLOAD_DOCUMENT: 'http/uploadDocument',
  CLIENT_VERIFICATION: 'http/clientVerification',
  DRAFT_APPLICATION: 'http/draftApplication',
};
